import React from 'react';

import { Box } from 'components/Box';
import { colors, fontWeights } from 'theme';

export type Status = 'NEW';

const getStatus: (arg0: Status) => {
  theme: {
    bg: string;
    color: string;
  };
  label: string;
} = (status) => {
  switch (status) {
    case 'NEW':
    default:
      return {
        theme: {
          color: 'white',
          bg: colors.waterBlue,
        },
        label: getText('New'),
      };
  }
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, @typescript-eslint/no-explicit-any
export const StatusTag = (props: Record<string, any>) => (
  <Box
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    data-qa-id={props['data-qa-id'] ? props['data-qa-id'] : 'listing-status'}
    display="inline-block"
    py="3px"
    px="5px"
    borderRadius="4px"
    letterSpacing="1px"
    textTransform="uppercase"
    lineHeight={1}
    fontWeight={fontWeights.semiBold}
    fontSize={11}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition, import/no-default-export
export default ({ status }: { status: Status }) => {
  const { theme, label } = getStatus(status);
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StatusTag mb={12} {...theme}>
      {label}
    </StatusTag>
  );
};
